export const LIMITED_ACCESS = "Limited";
export const FULL_ACCESS = "Full";
